import React from 'react';
import './QuestionHint.css';

interface QuestionHintProps {
  hint: string;
  variant?: 'question' | 'answers'; // Where the hint is displayed
}

export const QuestionHint: React.FC<QuestionHintProps> = ({ hint, variant = 'question' }) => {
  return (
    <div className={`question-hint question-hint--${variant}`}>
      <p className="question-hint__label">
        💡 Hint
      </p>
      <p className="question-hint__text">
        {hint}
      </p>
    </div>
  );
};
